'use client'

import { useEffect, useState } from 'react'
import { twMerge } from 'tailwind-merge'

interface TimeCountdownProps {
  defaultTime?: number
  cardClassName?: string
}

export default function TimeCountdown({
  defaultTime,
  cardClassName,
}: TimeCountdownProps) {
  const [time, setTime] = useState(defaultTime || 0)

  useEffect(() => {
    const timer = setInterval(() => {
      setTime((time) => {
        if (time === 0) {
          clearInterval(timer)
          return 0
        } else return time - 1
      })

      return () => clearInterval(timer)
    }, 1000)
  }, [])

  const days = Math.max(Math.floor(time / (24 * 3600)), 0)
  const hours = Math.max(Math.floor((time % (24 * 3600)) / 3600), 0)
  const minutes = Math.max(Math.ceil((time % 3600) / 60), 0)

  const cardClasses = twMerge(
    'w-12 h-18 py-4 bg-white rounded-lg flex-col justify-center items-center gap-2 flex',
    cardClassName
  )

  return (
    <>
      <div className="justify-start items-center gap-4 inline-flex">
        <div className="justify-start items-start gap-2 flex">
          <div className={cardClasses}>
            <div className="text-gray-800 text-2xl font-bold">{days}</div>
            <div className="text-gray-500 text-sm">days</div>
          </div>
          <div className={cardClasses}>
            <div className="text-gray-800 text-2xl font-bold">{hours}</div>
            <div className="text-gray-500 text-sm">hrs</div>
          </div>
          <div className={cardClasses}>
            <div className="text-gray-800 text-2xl font-bold">{minutes}</div>
            <div className="text-gray-500 text-sm">mins</div>
          </div>
        </div>
      </div>
    </>
  )
}
